import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface LegalInformationLawyer {
  /** relationship_id from GET /consumer/v3/prereads/:id/shared-with — never an array index or generated id */
  id: string;
  name: string;
  email?: string;
  firmName?: string;
}

export interface ShareLegalInformationConfirmationData {
  document: {
    title?: string;
    name?: string;
    [key: string]: any;
  };
  /** The lawyers this confirmation is about (already filtered to just the new shares, or the single lawyer being unshared) */
  selectedLawyers: LegalInformationLawyer[];
  action?: 'share' | 'unshare';
}

@Component({
  selector: 'app-share-legal-information-confirmation-dialog',
  templateUrl: './share-legal-information-confirmation-dialog.component.html',
  styleUrls: ['./share-legal-information-confirmation-dialog.component.css'],
  standalone: false
})
export class ShareLegalInformationConfirmationDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<ShareLegalInformationConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ShareLegalInformationConfirmationData
  ) { }

  onCancel(): void {
    // No API call, no mutation — just close.
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  isUnshareAction(): boolean {
    return this.data.action === 'unshare';
  }

  getDocumentName(): string {
    return this.data.document?.title || this.data.document?.name || '';
  }

  getSelectedNames(): string {
    const people = this.data.selectedLawyers || [];
    if (!people.length) { return ''; }
    if (people.length === 1) { return people[0].name; }
    if (people.length === 2) { return `${people[0].name} and ${people[1].name}`; }
    return `${people[0].name} and ${people.length - 1} others`;
  }

  getActionTitle(): string {
    return this.isUnshareAction() ? 'unshare' : 'share';
  }

  getConfirmButtonText(): string {
    return this.isUnshareAction() ? 'Yes, Unshare' : 'Yes, Share';
  }

  getConfirmButtonColor(): string {
    return this.isUnshareAction() ? 'warn' : 'primary';
  }
}